const inlineStyles = {

  modalBody: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '0 30px 30px 30px',
      marginTop: '-100px',
      width: '100%',
      maxWidth: '400px',
      marginLeft: 'auto',
      marginRight: 'auto'
  },

  buttonWrapper: {
    paddingTop: '16px'
  }
}

export default inlineStyles
